export default "__VITE_ASSET__138a3a60__"